var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.39703 17.997V9.80105H9.16203L9.57303 6.59205H6.39703V4.54805C6.39703 3.62205 6.65503 2.98805 7.98403 2.98805H9.66803V0.127047C8.84867 0.0392382 8.02508 -0.00316009 7.20103 4.70959e-05C4.75703 4.70959e-05 3.07903 1.49205 3.07903 4.23105V6.58605H0.332031V9.79505H3.08503V17.997H6.39703Z",
    fill: "#ffffff "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b7aab8e1fed3b39a1082e9b20db3a32b.svg";
export { ForwardRef as ReactComponent };